import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ThemeMode = 'dark' | 'light';

/**
 * 3 design systems:
 * - editorial: actual (serif elegante, ámbar, dark first)
 * - neo-brutalist: bloques de color sólidos, sombras duras 4px, mayúsculas display
 * - greta: cream + grises cálidos + rosa hocico + Schibsted + Caveat
 */
export type ThemeStyle = 'editorial' | 'neo-brutalist' | 'greta';

interface ThemeState {
  mode: ThemeMode;
  style: ThemeStyle;
  hasUserPreference: boolean;
  setMode: (mode: ThemeMode) => void;
  setStyle: (style: ThemeStyle) => void;
  toggle: () => void;
}

const getSystemTheme = (): ThemeMode => {
  if (typeof window === 'undefined') return 'dark';
  return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
};

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: getSystemTheme(),
      style: 'editorial',
      hasUserPreference: false,
      setMode: (mode) => set({ mode, hasUserPreference: true }),
      setStyle: (style) => set({ style }),
      toggle: () =>
        set({ mode: get().mode === 'dark' ? 'light' : 'dark', hasUserPreference: true }),
    }),
    {
      name: 'gretabot.theme',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
